module.exports = __webpack_public_path__ + "img/Verka-Header.efa3c7a8.webp";